import React, { useContext } from "react"
import PropTypes from "prop-types"
import { Col, Typography, Space, Tag } from "antd"
import {
  getReadableValue
} from "../../../helpers/selectOptions/getReadableValue"
import {
  submissionStatusOptions
} from "../../../helpers/selectOptions/shared/submission-status"
import {
  projectStatusOptions
} from "../../../helpers/selectOptions/shared/project-status"
import numeral from "numeral"
import { useRouter } from "next/router"
import { DashboardsProjectsContext } from "../../../contexts/dashboards/projects"

SubmissionReviewHeader.propTypes = {
  data: PropTypes.object,
  isProject: PropTypes.bool
}

export function SubmissionReviewHeader({ data, isProject = false }) {

  const { sideBarValues } = useContext(DashboardsProjectsContext)

  const router = useRouter() || {}

  const redColor = "#80010C"

  const formatMoney = value => {
    return numeral(value).format("$0,0.00")
  }

  const onImplementerProfile = () => {
    router.push({
      pathname: `/dashboards/implementer/${data.implementer.id}`,
      query: { step: sideBarValues.step, submenu: sideBarValues.submenu }
    })
  }
  return (
    <>
      <Col span={24}>
        <Typography.Title
          level={3}
          style={{ color: redColor }}>
          {data?.name}
        </Typography.Title>
      </Col>
      <Col span={24}>
        <Space direction="horizontal">
          <Typography.Title level={3} strong>{formatMoney(data?.approved)}</Typography.Title>
          <div className="submission-review-text-top">
            <Typography.Text>Solicitado</Typography.Text>
          </div>
          <div className="submission-review-text-middle">
            <Typography.Text style={{ color: redColor, marginLeft: "2.0rem" }}>
              Estatus:
            </Typography.Text>
          </div>
          <div className="submission-review-text-middle">
            <Tag>
              {getReadableValue(isProject ? projectStatusOptions : submissionStatusOptions, data?.status)}
            </Tag>
          </div>
        </Space>
      </Col>
      <Col span={24}>
        <Space direction="horizontal">
          <Typography.Text style={{ color: redColor, fontSize: "14px" }}>
            Implementadora:
          </Typography.Text>
          <Typography.Text style={{ fontSize: "17px" }}>
            {data?.implementer?.name}
          </Typography.Text>
          <Typography.Link
            style={{ fontSize: "17px" }}
            onClick={onImplementerProfile}
            underline>
            ver perfil
          </Typography.Link>
        </Space>
      </Col>
      <Col span={24}>
        <Space direction="horizontal">
          <Typography.Text style={{ color: redColor }}>
            Región:
          </Typography.Text>
          <Typography.Text style={{ fontSize: "17px" }}>
            {data?.region}
          </Typography.Text>
        </Space>
      </Col>
    </>
  )
}
